import { totalStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsTotal";
import { css } from "styled-components";

Object.assign(totalStyles, {
    subtotalLabelText: {
        css: css`
            text-transform: lowercase;
            & :first-letter {
                text-transform: uppercase;
            }
        `,
    },
    container: {
        gap: 10,
        css: css`
            background-color: rgb(237, 244, 248);
            padding: 20px;
            border-radius: 8px;
            @media print {
                -webkit-print-color-adjust: exact;
            }
        `,
    },
});
